<script setup>
import {computed} from 'vue'
import PagePath from '@/common/PagePath'
import {usePagePathStore} from '@/stores/pagePath'
import {usePageContentDataStore} from '@/stores/pageContentData'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    column: Object,
    value: Number
})

const pagePathStore = usePagePathStore()
const pageContentDataStore = usePageContentDataStore()
const appStore = useAppStore()

const pageId = computed(() => {
    return props.column.targetContent ? 0 : props.value
})

const pageContentId = computed(() => {
    return props.column.targetContent ? props.value : 0
})

const openLink = () => {
    let targetPageId
    if (pageContentId.value) {
        targetPageId = pageContentDataStore.items.filter((obj) => {
            return obj.id === props.value
        })[0]?.pageId
    } else {
        targetPageId = props.value
    }

    pagePathStore.get({
            pageId: targetPageId
        })
        .then((path) => {
            let url = appStore.websiteEndpoint + path

            if (pageContentId.value) {
                url += '#c' + pageContentId.value
            }

            window.open(url)
        })
}
</script>

<template>
    <span v-if="value" class="table-cell-hidden-icon-parent">
        <small><PagePath :page-id="pageId" :page-content-id="pageContentId"/></small>
        <a class="bi-box-arrow-up-right table-cell-hidden-icon" href @click.prevent="openLink"></a>
    </span>
</template>